import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AppModule } from './app/app.module';
import { environment } from './environments/environment';

if (environment.production) {
  enableProdMode();
} else if (window.location.hostname === 'localhost') {
  // If dev mode set environment oAuth return and logout url basing on current url (possible both 8080 and 8081)
  // prevent using hardcoded value
  const port = window.location.port;

  if (port !== '8080') {
    const newUrl = 'http://localhost:' + port;

    environment.authConfig.logoutRedirectUri = newUrl;
    environment.oAuthConfig.redirectUri = newUrl;
  }
}

platformBrowserDynamic()
  .bootstrapModule(AppModule)
  .catch((err: any) => console.log(err));
